module.exports = __webpack_public_path__ + "static/NV-50bdbd2266778b1123826d5439e08710.svg";